import { useEffect } from "react";

import { currentSurface } from "./host";
import { useVenue } from "./queries";

/** Tab title: "{venue} - RewardPass" on a venue host, "Operator - RewardPass" on the admin host. */
export function useDocumentTitle() {
  const operator = currentSurface() === "operator";
  const venue = useVenue();
  const name = operator ? "Operator" : venue.data?.name;
  useEffect(() => {
    document.title = name ? `${name} - RewardPass` : "RewardPass";
  }, [name]);
}
